<div class="listing-container"
     [class.overflow-auto-and-scroll]="isArticlesFolders || isArticles"
     [class.listing-container-vs-toolbar]="application.bottomToolbar === 'Y'">
  <!-- Clients virtual scroll -->
  <cdk-virtual-scroll-viewport *ngIf="isClients && isItemsLoaded && folderExist"
                               itemSize="80" minBufferPx="300" maxBufferPx="600"
    class="cdk-scroll">
    <div class="file-row center75 first noselect" [class.is-selected]="isArrowUpActive && !isRoot"
      [class.root]="isRoot">
      <div class="file-name" (click)="goUp()">
        <span *ngIf="isRoot; else arrowUp">
          {{ isClients ? 'Users/Clients' : 'Todo change'}}
        </span>
        <ng-template #arrowUp>
          <span class="noselect">
            <mat-icon class="accent-icon" style="margin-left: 0px;
              vertical-align: sub;">arrow_upwards</mat-icon> ..
          </span>
        </ng-template>
      </div>
      <div class="file-menu">
        <app-sort-button *ngIf="isClients" [state]="application.state"></app-sort-button>
      </div>
    </div>

    <app-listing-item *cdkVirtualFor="let listItem of listing.listItems;" [listItem]="listItem"
                      [activeItemCounter]="listing.selectedListItems.length" [operationsAllowed]="operationsAllowed"
                      (filemenu)="handleFileMenu(listItem)" (hidecontext)="mouseOut($event)"
                      (contextmenu)="onContextOpenMenu($event,listItem)" (click)="clickOnItem($event,listItem)"
                      (download)="handleReportDownload()" (info)="handleProfileInfo()" (zero)="handleZeroPoints()" (rename)="handleRename()" (delete)="handleDelete()">
    </app-listing-item>

    <section *ngIf="!listing.listItems.length;" class="empty-folder" fxLayout="column" fxLayoutAlign="center center"
      style="text-align: center;">
      <span *ngIf="!isFilterActive; else emptyAfterFilter">
        <mat-icon>folder_open</mat-icon>
        <p *ngIf="isClients">No clients found.</p>
        <p *ngIf="isArticlesFolders">No collections found.</p>
        <p *ngIf="isArticles">No articles in this collection found.</p>
        <p class="secondary" *ngIf="isClients">Click <span class="link">here</span> to create new record manually.</p>
      </span>
      <ng-template #emptyAfterFilter>
        <mat-icon>search</mat-icon>
        <p>No filter results.</p>
        <p class="secondary">Try another query</p>
      </ng-template>
    </section>
  </cdk-virtual-scroll-viewport>

  <div class="tiles-scroll-container center75" *ngIf="isItemsLoaded && (isArticlesFolders)">
    <app-tile-listing-item *ngFor="let listItem of listing.listItems; let j = index" [idx]="j" [listItem]="listItem"
                           [activeItemCounter]="listing.selectedListItems.length" [operationsAllowed]="operationsAllowed"
                           [viewState]="'course'"
                           (clickEditFolder)="clickEditFolder($event,listItem)"
                           (clickCourseShares)="clickCourseShares($event,listItem)"
                           (click)="clickOnAlrticlesFolder($event,listItem)">
    </app-tile-listing-item>
    <div class="clear_both">&nbsp;</div>
  </div>

  <div class="tiles-scroll-container center75" *ngIf="isItemsLoaded && (isArticles)">
    <div *ngFor="let categoryItem of listing.listItems; let i = index">
      <div class="article-category">
        <div style="width:65%;">
          {{i+1}}. {{categoryItem['group_name'] ? categoryItem['group_name'] : 'Random category'}}
          <!--<button mat-icon-button class="category-title-button" (click)="showCategoryRenamePopup(i)">-->
            <!--<mat-icon class="article-action-icon" color="accent" [matTooltip]="'Edit'">edit</mat-icon>-->
          <!--</button>-->
        </div>
        <div class="article-items-qty" style="width:35%;">
          <div>
            {{categoryItem['articles'].length}} articles
          </div>
          <div *ngIf="application.isTrainerLogin()" style="padding: 0px;">
            <button mat-icon-button class="article-items-btn" (click)="showCategoryRenamePopup(i)">
              <mat-icon class="article-action-icon material-icons-outlined" color="accent" [matTooltip]="'Edit'">edit</mat-icon>
            </button>
            <button mat-icon-button class="article-items-btn" (click)="newArticle(i)">
              <mat-icon class="article-action-icon " color="accent" [matTooltip]="'New article'">note_add</mat-icon>
            </button>
            <button mat-icon-button class="article-items-btn" (click)="showReorderPopup(i)">
              <mat-icon class="article-action-icon material-icons-outlined" color="accent" [matTooltip]="'Change order'">open_with</mat-icon>
              <!--<svg width="24px" fill="currentColor" viewBox="0 0 24 24">-->
                <!--<path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>-->
                <!--<path d="M0 0h24v24H0z" fill="none"></path>-->
              <!--</svg>-->
            </button>
            <button mat-icon-button class="article-items-btn" (click)="deleteArticlesCategoryOrItem('articles-category-delete',i)">
              <mat-icon class="article-action-icon material-icons-outlined" color="accent" [matTooltip]="'Delete'">delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
      <app-tile-listing-item *ngFor="let listItem of categoryItem['articles']; let j = index" [idx]="j" [listItem]="listItem"
                             [activeItemCounter]="listing.selectedListItems.length" [operationsAllowed]="operationsAllowed"
                             [viewState]="'article'"
                             (click)="clickOnArticleItem($event,listItem)"
                             (clickEdit)="clickOnArticleItem($event,listItem,false,true)"
                             (clickStatic)="clickOnArticleItem($event,listItem,true)"
                             (reorder)="clickOnAlrticleReorder($event,listItem,i,j)"
                             (export)="exportArticleItem($event,listItem)"
                             (delete)="deleteArticlesCategoryOrItem('article-delete',i,j)">
      </app-tile-listing-item>
    </div>
  </div>

  <!--<div class="tiles-scroll-container center75" *ngIf="isItemsLoaded && (isArticles)">-->
    <!--<div *ngFor="let listItem of listing.listItems; let i = index">-->
      <!--<div class="group-title">group-title {{i}}</div>-->
      <!--<app-tile-listing-item *ngFor="let listItem of listing.listItems; let i = index" [idx]="i" [listItem]="listItem"-->
                             <!--[activeItemCounter]="listing.selectedListItems.length" [operationsAllowed]="operationsAllowed"-->
                             <!--[isArticlesViewState]="isArticles"-->
                             <!--(click)="clickOnAlrticlesFolder($event,listItem)">-->
      <!--</app-tile-listing-item>-->
    <!--</div>-->
  <!--</div>-->

  <app-folder-doesnot-exist *ngIf="isItemsLoaded && !folderExist" (back)="handleGoToAll()">
  </app-folder-doesnot-exist>
  <div *ngIf="!isItemsLoaded" class="internal-spinner">
    <svg class="spinner" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
    </svg>
  </div>

</div>
<app-bottom-toolbar *ngIf="application.bottomToolbar === 'Y'"
                    [state]="application.state"
                    [fileCounter]="listing && listing.listItems ? listing.listItems.length : 0"
                    [activeFileCounter]="listing && listing.listItems ? listing.selectedListItems.length : 0"
                    (clear)="clearAfterAction()"
                    (download)="handleReportDownload()" (info)="handleProfileInfo()" (zero)="handleZeroPoints()" (rename)="handleRename()" (delete)="handleDelete()">
</app-bottom-toolbar>

<!-- lazy to maintain. disabled for now -->
<div *ngIf="isItemsLoaded" #contextMenu class="context-menu" [class.visible]="contextMenuStyles.isVisible"
  (mouseleave)="hideContextMenu()" [style.top]="contextMenuStyles.y" [style.left]="contextMenuStyles.x">
  <div class="items-counter" *ngIf="listing.selectedListItems.length > 1">SELECTED
    {{listing.selectedListItems.length}} ITEMS</div>

  <button *ngIf="activeItem" (click)="handleReportDownload()" mat-menu-item>
    <mat-icon>file_download</mat-icon>
    Points report
  </button>
  <button *ngIf="activeItem" (click)="handleZeroPoints()" mat-menu-item>
    <mat-icon>exposure_zero</mat-icon>
    Set points to zero
  </button>
  <hr>
  <button *ngIf="activeItem" mat-menu-item (click)="handleRename()">
    <mat-icon>edit</mat-icon> Rename
  </button>
  <button *ngIf="activeItem" mat-menu-item (click)="handleDelete()">
    <mat-icon color="warn">delete</mat-icon> Delete
  </button>
</div>
<iframe #downloadFrame title="download_frame" style="width: 1px; height: 1px; display: none;"></iframe>
